import React, { useRef, useEffect, memo } from "react";
import {
  LandingContainer,
  NavigationItem,
  NavigationImage,
} from "../styles/components/landing";
import animations from "../animations/animations";

const LandingNavigation = ({ content }) => {
  const navigationItems = useRef([]);
  navigationItems.current = [];

  const setRef = (idx, el) => {
    if (el) navigationItems.current[idx] = el;
  };

  useEffect(() => {
    const offsetX = 5;
    const offsetY = 25;

    animations.set(navigationItems.current, {
      filter: "blur(3px)",
      x: index => -offsetX * index,
      y: index => offsetY * index,
      zIndex: index => navigationItems.current.length - index,
    });
  }, []);

  return (
    <LandingContainer className="trident-container landing-navigation">
      {content
        ?.filter(item => item.active)
        .map((item, activeIdx) => {
          const image = item.navigationImage?.[0]?.image?.fluid?.src;
          const aspectRatio =
            item.navigationImage?.[0]?.image?.fluid?.aspectRatio;

          return (
            <NavigationItem
              key={item.key}
              id={`navigation-${activeIdx}`}
              ref={el => setRef(activeIdx, el)}
            >
              <NavigationImage src={image} $aspectRatio={aspectRatio} />
            </NavigationItem>
          );
        })}
    </LandingContainer>
  );
};

export default memo(LandingNavigation);
